import { useMutation, gql } from '@apollo/client';

import { GET_NOTIFICATIONS } from './get-notifications.hook';

export const READ_NOTIFICATION = gql`
  mutation readNotification($notificationId: ObjectId!) {
    readNotification(notificationId: $notificationId)
  }
`;

export const useReadNotification = () => {
  const [mutate] = useMutation(READ_NOTIFICATION, { refetchQueries: [GET_NOTIFICATIONS] });

  return mutate;
};
